const data = [
    {
        img:"https://res.cloudinary.com/dycitvrpg/image/upload/v1681462004/dietPlan_etyfq2.png",
        featureName: "Diet Plan",
        desc:"Our app creates personalized diet plans based on the food items you choose. You can select from a variety of foods to create a plan that fits your unique needs and preferences.",
        color:" #C40000",
        route:"/dietPlan"
    },
    {
        img:"https://res.cloudinary.com/dycitvrpg/image/upload/v1681462004/gymPlan_esryc7.png",
        featureName: "Gym Plan",
        desc:"Our app creates custom gym plans tailored to your unique needs and goals. You can select exercises that fit your preferences and workout schedule to get the most out of your gym experience.",
        color:"#FCFA50",
        route:"/gymplan"
    },
    {
        img:"https://res.cloudinary.com/dycitvrpg/image/upload/v1681462004/community_ofj50l.png",
        featureName:"Community",
        desc:"Our app has a thriving social community of fitness enthusiasts, where you can learn and connect with like-minded individuals. Join the conversation and share your experiences and tips.",
        color:"#ADF1D0",
        route:"/community",
    },
    {
        img:"https://res.cloudinary.com/dycitvrpg/image/upload/v1681462004/fitbot_bng0zg.png",
        featureName:"Fitbot",
        desc:"An AI bot that can help answer all your fitness questions. Whether you need advice on nutrition, workout routines, our bot is available 24/7 to provide you with expert guidance.",
        color:"#7A5EE5",
        route:"/fitbot",
    },
    {
        img:"https://res.cloudinary.com/dycitvrpg/image/upload/v1681462004/shop_l0xkiu.png",
        featureName:"FitMart",
        desc:"An e-shop for all your fitness needs, offering a wide range of original supplements and workout gear. You can browse and purchase products from top brands, all in one convenient location.",
        color:"#01ABB2",
        route:"/shop",
    }
]

export default data;